import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorMessage, ModalService } from '@com-delta-omnichannel/aura';
import { OverviewPage } from './models/overview-page.interfaces';

@Component({
  selector: 'idp-overview-page',
  templateUrl: './overview-page.component.html',
  styleUrls: ['./overview-page.component.scss']
})
export class OverviewPageComponent {
  @Input() content: OverviewPage = {} as OverviewPage;
  @Output() openLink = new EventEmitter<string>();
  showModal = false;

  constructor(public modalService: ModalService) {}

  getFullError(error: ErrorMessage | undefined) {
    return error
      ? ({
          ...error,
          container: { height: 'full' }
        } as ErrorMessage)
      : undefined;
  }

  opened(value: boolean) {
    if (value) {
      this.modalService.overlayRef.updateSize({
        width: window.innerWidth <= 768 ? '90%' : '80%'
      });
    }
  }

  redirect(link: string) {
    this.openLink.emit(link);
  }
}
